var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"m-curriculum"},[_c('img',{attrs:{"src":"http://cssn.lexiangwx.com/png/R354726147348664320.png","alt":"财商少年课程系列"}})])}]

export { render, staticRenderFns }